import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
const MotifAccordionGroup = (props) => {
  const { children } = props;
  const [activeIndex, setActiveIndex] = useState(null);

  return React.Children.map(children, (child, index) => {
    const open = index === activeIndex;

    return React.cloneElement(child, {
      onClose: () => {
        if (open) {
          setActiveIndex(null);
          if (child.props.onClose) {
            child.props.onClose();
          }
        }
      },
      onOpen: () => {
        if (!open) {
          setActiveIndex(index);
          if (child.props.onOpen) {
            child.props.onOpen();
          }
        }
      },
      open
    });
  });
};

MotifAccordionGroup.propTypes = {
  children: PropTypes.node
};

export { MotifAccordionGroup };
